
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppFileUpload, AppImageHolder } from '@/components';
import { useArenaMedalEdit } from '@/modules/arena/medal/model/edit';
import { ROUTE_NAME_ARENA } from '@/modules/arena/router';

export default defineComponent({
    name: ROUTE_NAME_ARENA.MEDAL.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppFileUpload, AppImageHolder },
    setup() {
        const { model, v$, actions } = useArenaMedalEdit();

        onMounted(() => {
            actions.fetch();
        });

        return { v$, model, actions };
    }
});
